import CoreUtils from '../../utils/coreUtils.js';
import { PARAM_TYPE, PARAM_UNITS } from './connector.js';

export default class CompoundParameter
{
	constructor(initValues, eSpecificType)
	{
		this.parameters = initValues;
		this.specificType = eSpecificType;
	}

	static create(eParamType)
	{
		let pInitValues = [];

		// Note you can add the 'label' field to each sub-parameter for a custom label.
		if(eParamType === PARAM_TYPE.MATERIAL_TWEAKS)
		{
			pInitValues.push({ name: 'brightness', value: 0.0, type: PARAM_TYPE.FLOAT, minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT });
			pInitValues.push({ name: 'contrast', value: 0.0, type: PARAM_TYPE.FLOAT, minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT });
			pInitValues.push({ name: 'hue', value: 0.0, type: PARAM_TYPE.FLOAT, minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT });
			pInitValues.push({ name: 'saturation', value: 0.0, type: PARAM_TYPE.FLOAT, minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT  });
			pInitValues.push({ name: 'cyan_red', value: 0.0, type: PARAM_TYPE.FLOAT, minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT  });
			pInitValues.push({ name: 'magenta_green', value: 0.0, type: PARAM_TYPE.FLOAT, minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT  });
			pInitValues.push({ name: 'yellow_blue', value: 0.0, type: PARAM_TYPE.FLOAT, minValue: -100, maxValue: 100, units: PARAM_UNITS.PERCENT  });			
		}

		return new CompoundParameter(pInitValues, eParamType);
	}

	static isCompoundParamType(eParamType)
	{
		if(eParamType === PARAM_TYPE.MATERIAL_TWEAKS)
			return true;

		return false;
	}

	getSpecificType()
	{
		return this.specificType;
	}

	getParameterInfos()
	{
		return this.parameters.slice(0);
	}

	findParameterInfo(strName)
	{
		for(let pInfo of this.parameters)
		{
			if(pInfo.name == strName)
				return pInfo;
		}

		return null;
	}

	getValue(strName)
	{
		let pInfo = this.findParameterInfo(strName);
		if(pInfo)
			return pInfo.value;
		else
			return 0.0;
	}

	setValue(strName, value)
	{
		let pInfo = this.findParameterInfo(strName);
		if(pInfo)
			pInfo.value = value;
	}

	clone()
	{
		let pObj = this.saveToObject();
		return CompoundParameter.loadFromObject(pObj);
	}

	saveToObject()
	{
		let pRes = {};
		pRes['type'] = 'compound';
		pRes['specType'] = this.specificType;
		pRes['parameters'] = CoreUtils.clone(this.parameters);
		return pRes;
	}

	static loadFromObject(pObj)
	{
		return new CompoundParameter(pObj['parameters'], pObj['specType']);
	}
}